var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 120,
    viewBox: "0 0 114 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 0C10.866 0 14 3.13401 14 7V89C14 98.3888 21.6112 106 31 106H83C92.3888 106 100 98.3888 100 89V7C100 3.13401 103.134 0 107 0C110.866 0 114 3.13401 114 7V89C114 106.121 100.121 120 83 120H31C13.8792 120 0 106.121 0 89V7C0 3.13401 3.13401 0 7 0ZM40 28C43.866 28 47 31.134 47 35V83C47 86.866 43.866 90 40 90C36.134 90 33 86.866 33 83V35C33 31.134 36.134 28 40 28ZM80 35C80 31.134 76.866 28 73 28C69.134 28 66 31.134 66 35V83C66 86.866 69.134 90 73 90C76.866 90 80 86.866 80 83V35Z",
    fill: "#ED3C5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoShort);
export default __webpack_public_path__ + "static/media/logo-short.127ef01f29e44e7bb517112486bfb51f.svg";
export { ForwardRef as ReactComponent };